import request from '@/utils/request'

// 获取首页轮播图
export function getHomeBannerList(query) {
    return request({
      url: '/web/management/list',
      method: 'get',
      params: query
    })
}
// 分类
export function getSelect(query) {
  return request({
    url: '/web/category/list',
    method: 'get',
    params: query
  })
}

// 查询列表
export function queryList(query) {
  return request({
    url: '/web/strip/list',
    method: 'get',
    params: query
  })
}
export function addSearch(params) {
  return request({
    url: '/web/history/search',
    method: 'post',
    data: params
  })
}

// 首页查询列表
export function homeQueryList(guid) {
  return request({
    url: '/web/strip/listNewById/' + guid,
    method: 'get',
    // params: query
  })
}

// 验证码
export function getCodeImg(query) {
  return request({
    url: '/captchaImage',
    method: 'get',
    params: query
  })
}

// 登录
export function login(params) {
  return request({
    url: '/front/auth/login',
    method: 'post',
    data: params
  })
}

// 获取用户信息
export function getUserIofo(query) {
  return request({
    url: '/front/auth/getInfo',
    method: 'get',
    params: query
  })
}

// 退出登录
export function logOut() {
  return request({
    url: '/front/auth/logout',
    method: 'get',
  })
}

// 浏览量
export function addView(params) {
  return request({
    url: '/web/history/browsing',
    method: 'post',
    data: params
  })
}

// 当前书的阅读量
export function addBookView(params) {
  return request({
    url: '/web/footprint/addCache',
    method: 'post',
    data: params
  })
}

// 个人中心-我的足迹
export function getZuJiData(query) {
  return request({
    url: '/web/footprint/listByUser',
    method: 'get',
    params: query
  })
}

// 个人中心-删除我的足迹
export function delectZuJi(params) {
  return request({
    url: '/web/footprint/rem/stripBook',
    method: 'post',
    data: params
  })
}

// 个人中心-我的打卡
export function getDaKaData(query) {
  return request({
    url: '/system/check/list',
    method: 'get',
    params: query
  })
}

// 个人中心-打卡
export function updateDaKa(params) {
  return request({
    url: '/system/check',
    method: 'post',
    data: params
  })
}

// 个人中心-我的收藏
export function getCollectList(query) {
  return request({
    url: '/web/history/collect/list',
    method: 'get',
    params: query
  })
}

// 点击收藏
export function addCollect(params) {
  return request({
    url: '/web/history/collect',
    method: 'post',
    data: params
  })
}

// 取消收藏
export function delectCollect(params) {
  return request({
    url: '/web/history/collect/rem/book',
    method: 'post',
    data: params
  })
}
// 个人中心-虚拟头像
export function updateAvatar(params) {
  return request({
    url: '/web/Userinfo/upd',
    method: 'post',
    data: params
  })
}


